module.exports = __webpack_public_path__ + "static/media/system3-logo.3df70ad4.svg";